import React, { useState } from "react";
import { Button, Image } from "react-bootstrap";
import { toast } from "react-toastify";
import { Alert, AlertTitle } from "@material-ui/lab";
import AppBar from "@material-ui/core/AppBar";

import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
// import rabbit from "../../assets/img/bannyAuth.png";
import lusukuLogoMain from "../../assets/img/lusuku_logo_main.png";
import { useHistory } from "react-router";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

const MobileClientPasswordResetForm = ({ match }) => {
  const classes = useStyles();
  const history = useHistory();
  const [resetStatus, setResetStatus] = useState("");
  const [success, setSuccess] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  //   console.log(success, "success?");
  // console.log(resetStatus, "reset Status");

  const user_id = match?.params?.id;
  const resetToken = match?.params?.token;
  const [input, setInput] = useState({
    password: "",
    confirmPassword: "",
  });

  const clearInput = () => {
    setInput({
      password: "",
      confirmPassword: "",
    });
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      setSubmitting(true);
      const response = await fetch(`/user/reset-password/${user_id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          password: values.password,
          resetToken,
        }),
      });
      const data = await response.json();
      // console.log(data, "data");
      setResetStatus(data.message);
      // toast.info(data.message);
      if (data.success) {
        // alert("Password reset successfully");
        toast.success("Password reset successfully!");
        setSuccess(true);
        history.replace("/agent-reset-password/:token/:id");
        setSubmitting(false);
      } else {
        // alert("Password reset failed");
        toast.info(data.message);
        history.replace("/agent-reset-password/:token/:id");
        clearInput();
      }
    } catch (error) {
      console.log(error);
    }
  };

  if (success) {
    return (
      <>
        <div className={classes.root}>
          <AppBar position="static" color="inherit" elevation={1}>
            <Toolbar>
              <Link to="/">
                <Image
                  src={lusukuLogoMain}
                  alt="Lusuku"
                  style={{ width: 60, height: 60, objectFit: "contain" }}
                />
              </Link>
            </Toolbar>
          </AppBar>
        </div>
        <div
          style={{
            minHeight: "calc(100vh - 100px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "32px 16px",
            background: "#f7f8fa",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 480,
              background: "#fff",
              borderRadius: 12,
              border: "1px solid #e5e7eb",
              boxShadow: "0 10px 30px rgba(15, 23, 42, 0.06)",
              padding: "40px 32px",
            }}
          >
            <div style={{ textAlign: "center", marginBottom: 20 }}>
              <div
                style={{
                  width: 64,
                  height: 64,
                  borderRadius: "50%",
                  background: "#ecfdf5",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 16,
                }}
              >
                <i
                  className="fas fa-check-circle"
                  style={{ fontSize: 32, color: "#16a34a" }}
                />
              </div>
              <h2
                style={{
                  fontSize: 22,
                  fontWeight: 700,
                  color: "#111827",
                  margin: 0,
                }}
              >
                Password Reset Successful
              </h2>
              <p
                style={{
                  marginTop: 10,
                  color: "#4b5563",
                  fontSize: 14,
                  lineHeight: 1.5,
                }}
              >
                {resetStatus || "Your password has been updated."} You can now
                log in to the Lusuku Mobile App with your new password.
              </p>
            </div>
            <p
              style={{
                textAlign: "center",
                marginTop: 12,
                marginBottom: 0,
                fontSize: 12,
                color: "#9ca3af",
              }}
            >
              You can close this window and return to the Lusuku app.
            </p>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className={classes.root}>
        <AppBar position="static" color="inherit">
          <Toolbar>
            <Link to="/">
              <Image
                src={lusukuLogoMain}
                alt="Lusuku"
                style={{ width: 60, height: 60, objectFit: "contain" }}
              />
            </Link>
          </Toolbar>
        </AppBar>
      </div>
      <div className="container pt-4">
        <div className="row">
          <div className="col-md-6 offset-md-3">
            <div className="card">
              <div className="card-body">
                <h1 style={{ fontSize: 30, fontWeight: 300 }}>
                  Lusuku Password Reset
                </h1>
                <Formik
                  initialValues={{
                    password: "",
                    confirmPassword: "",
                  }}
                  validationSchema={Yup.object({
                    password: Yup.string()
                      .required("Password is required!")
                      .min(8, "Password must be between 8 and 20 characters.")
                      .max(20, "Password must be between 8 and 20 characters.")
                      .matches(
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                        "Password must contain at least one uppercase, one lowercase, one number and one special character."
                      ),
                    confirmPassword: Yup.string()
                      .required("Confirm Password is required")
                      .oneOf(
                        [Yup.ref("password"), null],
                        "Passwords must match!"
                      ),
                  })}
                  onSubmit={handleSubmit}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                  }) => (
                    <Form onSubmit={handleSubmit}>
                      <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <div style={{ position: "relative" }}>
                          <Field
                            type={showPassword ? "text" : "password"}
                            name="password"
                            className={
                              "form-control" +
                              (errors.password && touched.password
                                ? " is-invalid"
                                : "")
                            }
                            style={{ paddingRight: 40 }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.password}
                          />
                          <button
                            type="button"
                            onClick={() => setShowPassword((s) => !s)}
                            aria-label={
                              showPassword ? "Hide password" : "Show password"
                            }
                            style={{
                              position: "absolute",
                              top: 0,
                              right: 0,
                              height: "100%",
                              width: 40,
                              border: "none",
                              background: "transparent",
                              color: "#6b7280",
                              cursor: "pointer",
                              padding: 0,
                            }}
                          >
                            <i
                              className={
                                showPassword ? "fas fa-eye-slash" : "fas fa-eye"
                              }
                            />
                          </button>
                        </div>
                        <ErrorMessage
                          name="password"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="confirmPassword">
                          Confirm Password
                        </label>
                        <div style={{ position: "relative" }}>
                          <Field
                            type={showConfirmPassword ? "text" : "password"}
                            name="confirmPassword"
                            className={
                              "form-control" +
                              (errors.confirmPassword && touched.confirmPassword
                                ? " is-invalid"
                                : "")
                            }
                            style={{ paddingRight: 40 }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.confirmPassword}
                          />
                          <button
                            type="button"
                            onClick={() => setShowConfirmPassword((s) => !s)}
                            aria-label={
                              showConfirmPassword
                                ? "Hide password"
                                : "Show password"
                            }
                            style={{
                              position: "absolute",
                              top: 0,
                              right: 0,
                              height: "100%",
                              width: 40,
                              border: "none",
                              background: "transparent",
                              color: "#6b7280",
                              cursor: "pointer",
                              padding: 0,
                            }}
                          >
                            <i
                              className={
                                showConfirmPassword
                                  ? "fas fa-eye-slash"
                                  : "fas fa-eye"
                              }
                            />
                          </button>
                        </div>
                        <ErrorMessage
                          name="confirmPassword"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </div>
                      <div className="form-group">
                        <button
                          type="submit"
                          className="btn btn-primary btn-block"
                          disabled={isSubmitting}
                        >
                          Reset Password
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileClientPasswordResetForm;
